import { render } from "./SupplierForm.vue?vue&type=template&id=5de80c6f&scoped=true"
import script from "./SupplierForm.vue?vue&type=script&lang=js"
export * from "./SupplierForm.vue?vue&type=script&lang=js"

import "./SupplierForm.vue?vue&type=style&index=0&id=5de80c6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de80c6f"]])

export default __exports__